import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LogoutButton from "./LogoutButton";
import dataService from "../../services/data.service";
import LoadingScreen from "../common/LoadingScreen";

const Profile = () => {
  const { user, isAuthenticated, isLoading} = useAuth0();

  if (isLoading) {
    return <LoadingScreen/>;
  }

  let pendo;
  let pendoInitilized = false;

  let loadPendo = () => {
    const userNameArr = user.name.split(" ");
    dataService.getUser().firstName = userNameArr[0];
    dataService.getUser().lastName = userNameArr[userNameArr.length - 1];


    const visitor = {
      id: user.email, // Required if user is logged in
      visitorId: user.name,
      email: user.email, // Recommended if using Pendo Feedback, or NPS Email
      full_name: user.name, // Recommended if using Pendo Feedback
      hgm_environment: process.env.ENVIRONMENT
      //  role:     this.isMDOUser    // Optional

      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
    }

    const account = {
      id: user.name+"2", // Highly recommended, required if using Pendo Feedback
      accountId: user.name+"2",
      name: user.name+"2",   // Optional
      hgm_environment: process.env.ENVIRONMENT,
      hmg_name: "test1",
      property_name: "test_prop1"
      // is_paying:    // Recommended if using Pendo Feedback
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    }

    // initialize pendo
    if (pendoInitilized) {
      window.pendo.updateOptions({
        visitor: visitor,
        account: account
      });
    } else {
      window.pendo.initialize({
        visitor: visitor,
        account: account
      });
      pendoInitilized = true;
    }
  }

  if(isAuthenticated){
    loadPendo();
  }
  return (
    isAuthenticated && (
      <div>
        {/* <img src={user.picture} alt={user.name} /> */}
        {/* <h2>Welcome, {user.name}</h2> */}
        {/* <p>{user.email}</p> */}
        {/* <LogoutButton></LogoutButton> */}
      </div>
    )
  );
};

export default Profile;